import { memo, useEffect } from "react";
import { Modal, ModalTitle, ModalContent } from "@ui-kit/Modal/Modal";
import { Register } from "./views/Register/Register";
import { SignInPassword } from "./views/SignInPassword/SignInPassword";
import { ResetPassword } from "./views/ResetPassword/ResetPassword";
import { ResetPasswordRequest } from "./views/ResetPasswordRequest/ResetPasswordRequest";

import "./AuthView.css";
import {
  selectAuthView,
  selectIsAuthViewOpen,
  setAuthViewAction,
} from "@store/sessionReducer";
import { useAppDispatch, useAppSelector } from "@store/store";
import { Trans } from "react-i18next";
import { SignInMagicLink } from "./views/SignInMagicLink/SignInMagicLink";
import { MagicLinkSent } from "./views/MagicLinkSent/MagicLinkSent";
import { MagicLinkExpired } from "./views/MagicLinkExpired/MagicLinkExpired";
import { SmsVerify } from "./views/SmsVerify/SmsVerify";
import { AdminOtpVerify } from "./views/AdminOtpVerify/AdminOtpVerify";
import { ResetPasswordRequestSent } from "./views/ResetPasswordRequestSent/ResetPasswordRequestSent";

const AuthView = memo(({ handleClose }: { handleClose: () => void }) => {
  const view = useAppSelector(selectAuthView);
  const isOpen = useAppSelector(selectIsAuthViewOpen);
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(setAuthViewAction({ authView: "signInEmail" }));
    };
  }, [dispatch]);

  return (
    <Modal open={isOpen} width={432} onClose={handleClose}>
      <ModalTitle>
        <Trans i18nKey={`screens.auth.${view}.title`} />
      </ModalTitle>
      <ModalContent>
        <div className="auth-view-component">
          {view === "register" && <Register />}
          {view === "signInPassword" && <SignInPassword />}
          {view === "signInEmail" && <SignInMagicLink />}
          {view === "signInSms" && <SignInMagicLink />}
          {view === "smsVerify" && <SmsVerify />}
          {view === "resetPasswordRequest" && <ResetPasswordRequest />}
          {view === "resetPasswordExpired" && <ResetPasswordRequest />}
          {view === "resetPasswordRequestSent" && <ResetPasswordRequestSent />}
          {view === "resetPassword" && <ResetPassword />}
          {view === "magicLinkSent" && <MagicLinkSent />}
          {view === "magicLinkExpired" && <MagicLinkExpired />}
          {view === "adminOtpVerify" && <AdminOtpVerify />}
        </div>
      </ModalContent>
    </Modal>
  );
});

AuthView.displayName = "AuthView";

export { AuthView };
